<div class="form-group mb-0">
  <label for="dropdown">{{label}}</label>
  <select class="form-control form-control-lg text-dark mb-0" id="dropdown" (change)="selectItem($event.target.value)">
    <option value="null" disabled="true" [selected]="true">{{ 'shared.label.select_value' | translate }}</option>
    <option *ngFor="let item of items" [value]="item.externalId">{{item.name | translate}}</option>
  </select>
</div>